export class EncodeUrl {
    url: URL;
    constructor(url: URL | string) {
        if (typeof url === 'string') {
            this.url = new URL(url);
        } else {
            this.url = url;
        }
    }

    encode(): string {
        return isEncoded(this.url.href) ? this.url.href : encodeURI(this.url.href);
    }
}

export const isEncoded = (url: string): boolean => {
    return /%\d{2}/.test(url);
};
